;(function () {
  /* neverover — quick-add bottom-sheet (#product-drawer) enhancements. Pure JS; reads the
     theme's own drawer DOM + lifecycle events. No Liquid edits.
       (A) Drag-to-close finishes as a smooth slide instead of leaving the panel parked
           half-open and fading (the theme's drag drops a stale rAF that kills its own
           close tween). We watch for the END of a drag and finish the gesture.
       (B) The drawer's Add-to-cart button shows the live, variant-aware price. */
  if (window.__nvPdp) return;
  window.__nvPdp = true;

  function drawer(){ return document.getElementById('product-drawer'); }
  function isOpen(){ var d = drawer(); return !!(d && d.classList.contains('show')); }

  /* ===========================================================================
     (A) Drag-to-close out-animation — gated strictly on the END of a drag
     (.dragging true -> false) so it never interferes with the OPEN animation.
     We read where the panel was released and finish the gesture the theme intended:
       released < 25% of panel height  -> snap back open (translateY 0)
       released >= 25%                 -> slide fully out (translateY = height)
     If the theme's own tween is already running, this just re-asserts the same target
     (harmless). Additive: we never touch the theme's drag handlers or the close button.
     =========================================================================== */
  function drive(c, target){
    c.style.transition = 'transform .3s cubic-bezier(.32,.72,0,1)';
    c.style.transform  = 'translate3d(0,' + target + 'px,0)';
  }
  function correct(){
    var d = drawer(); if (!d || !d.classList.contains('show')) return;
    var c = d.querySelector('.content'); if (!c) return;
    var y = 0; try { y = (new DOMMatrixReadOnly(getComputedStyle(c).transform)).m42 || 0; } catch (e) {}
    var h = c.scrollHeight || d.offsetHeight || 700;
    if (y < h * 0.02) return;                 // already home/open
    if (y < h * 0.25) drive(c, 0);            // clobbered restore -> tween back open
    else if (y < h * 0.97) drive(c, h);       // clobbered close   -> tween out
  }
  function scheduleCorrect(){
    requestAnimationFrame(function(){ requestAnimationFrame(correct); }); // after the stale rAF
    setTimeout(correct, 70);                                              // 2nd pass for a late clobber
  }
  (function watchDrag(){
    var d = drawer(); if (!d) return;
    var had = d.classList.contains('dragging');
    new MutationObserver(function(){
      var dd = drawer(); if (!dd) return;
      var has = dd.classList.contains('dragging');
      if (had && !has) scheduleCorrect();      // a drag just ended
      had = has;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ===========================================================================
     (B) Variant-aware price on the drawer Add-to-cart button (.pdr-addtocart).
     Reads the selected size radio's data-variant-id -> matching price template ->
     formatted price text (storefront money, tax notes stripped). Re-runs on open and
     on size change. Mirrors the existing PDP button-price look (.nv-btn-price).
     =========================================================================== */
  var SEP = ' — ';
  function scope(){
    var d = drawer(); if (!d || !d.classList.contains('show')) return null;
    return d.querySelector('#inject-inside-me') || d;
  }
  function cleanStr(s){ return (s == null ? '' : String(s)).replace(/tax\s*incl\.?/ig, '').replace(/\s+/g, ' ').trim(); }
  function priceText(el){
    if (!el) return '';
    var c = el.cloneNode(true);
    var junk = c.querySelectorAll('.extra-tax,.product-price__tax,.price__tax,.tax-note,.price-item--tax,.unit-price,.product-price__old-price');
    for (var i = 0; i < junk.length; i++) junk[i].remove();
    return cleanStr(c.textContent);
  }
  function variantId(sc){
    var r = sc.querySelector('input[type="radio"][data-variant-id]:checked')
         || sc.querySelector('.new-size-variant-item.selected input[type="radio"][data-variant-id]')
         || sc.querySelector('.new-size-variant-item.active input[type="radio"][data-variant-id]');
    if (r && r.getAttribute('data-variant-id')) return r.getAttribute('data-variant-id');
    var hid = sc.querySelector('[data-product-form-variant], input[name="id"]');
    return hid && hid.value ? hid.value : null;
  }
  function priceFor(sc, id){
    if (id){
      var tpl = sc.querySelector('template[data-product-block-template="' + id + '"]');
      if (tpl && tpl.content){
        var el = tpl.content.querySelector('.product-price__current-price, .price-item--regular, .price-item');
        var t = priceText(el); if (t) return t;
      }
    }
    return priceText(sc.querySelector('.product-price__current-price, .product-price-wrapper .price-item'));
  }
  function span(btn){
    var s = btn.querySelector('.nv-btn-price');
    if (!s){
      s = document.createElement('span');
      s.className = 'nv-btn-price';
      s.style.cssText = 'opacity:.6;font-variant-numeric:tabular-nums;white-space:nowrap;';
      btn.appendChild(s);
    }
    return s;
  }
  function busy(btn){
    // The drawer spinner is always present (display:block, hidden via opacity), so never key
    // off its display. Only treat the button as busy on an explicit loading/disabled state.
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return true;
    return /(^|\s)(loading|is-loading|btn--loading|adding)(\s|$)/i.test(btn.className || '');
  }
  var last = null;
  function update(){
    var sc = scope(); if (!sc) return;
    var btn = sc.querySelector('.pdr-addtocart'); if (!btn) return;
    var s = span(btn);
    if (busy(btn)) { s.style.visibility = 'hidden'; return; }
    var p = priceFor(sc, variantId(sc));
    if (p) last = p;
    var show = p || last;
    if (show){ s.style.visibility = ''; var t = SEP + show; if (s.textContent !== t) s.textContent = t; }
  }
  var tmr; function schedule(){ clearTimeout(tmr); tmr = setTimeout(update, 30); }

  window.addEventListener('pdr:opened', function(){ last = null; schedule(); setTimeout(schedule, 140); });
  document.addEventListener('change', function(e){ if (e.target.closest && e.target.closest('#product-drawer')) schedule(); }, true);
  document.addEventListener('click',  function(e){ if (e.target.closest && e.target.closest('#product-drawer .new-size-variant-item, #product-drawer [data-variant-picker-option-inputs-seconds]')) setTimeout(schedule, 20); }, true);
  (function watchBtn(){
    var d = drawer(); if (!d) return;
    new MutationObserver(function(){ if (isOpen()) schedule(); })
      .observe(d, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-busy'] });
  })();

  /* ============================================================
     (C) Require an EXPLICIT size choice before the drawer Add-to-cart adds.
     The theme pre-selects the first in-stock size, so a shopper could otherwise add a
     size they never chose. On open we clear the pre-selection; Add stays blocked (and
     bounces to the size list) until the shopper taps a size. Both click + submit are
     guarded since .pdr-addtocart is a type=submit button inside a <product-form>.
     ============================================================ */
  function dscope(){ var d = drawer(); return (d && d.classList.contains('show')) ? (d.querySelector('#inject-inside-me') || d) : null; }
  function dSizeRadios(sc){ return sc.querySelectorAll('.new-size-variant-item input[type="radio"], [data-variant-picker-option-inputs-seconds] input[type="radio"]'); }
  function markPicked(){ var sc = dscope(); if (sc) sc._nvPicked = true; }
  window.addEventListener('pdr:opened', function(){
    var sc = dscope(); if (!sc) return;
    sc._nvPicked = false;                       // require a fresh explicit pick on each open
    setTimeout(function(){                        // drop the theme's default highlight (visual only — never unchecks, so price/variant stay intact)
      var s = dscope(); if (!s) return;
      var it = s.querySelectorAll('.new-size-variant-item.selected, .new-size-variant-item.active');
      for (var i = 0; i < it.length; i++) it[i].classList.remove('selected', 'active');
    }, 60);
  });
  document.addEventListener('click',  function(e){ if (e.isTrusted && e.target.closest && e.target.closest('#product-drawer .new-size-variant-item')) markPicked(); }, true);
  document.addEventListener('change', function(e){ if (e.isTrusted && e.target.closest && e.target.closest('#product-drawer .new-size-variant-item, #product-drawer [data-variant-picker-option-inputs-seconds]')) markPicked(); }, true);
  function blockedNoSize(){ var sc = dscope(); return sc && dSizeRadios(sc).length && !sc._nvPicked ? sc : null; }
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('#product-drawer .pdr-addtocart');
    if (!btn) return;
    var sc = blockedNoSize(); if (!sc) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var list = sc.querySelector('.variants-inputs-wrapper, [data-variant-picker-option-inputs-seconds]') || sc;
    try { list.scrollIntoView({ behavior:'smooth', block:'center' }); } catch (e2){}
    list.style.transition = 'outline-color .3s ease';
    list.style.outline = '2px solid rgba(222,56,19,.7)';
    list.style.outlineOffset = '5px';
    setTimeout(function(){ list.style.outlineColor = 'transparent'; }, 1300);
    setTimeout(function(){ list.style.outline = ''; list.style.outlineOffset = ''; list.style.transition = ''; }, 1700);
  }, true);
  document.addEventListener('submit', function(e){
    var form = e.target; if (!form || form.tagName !== 'FORM' || !form.querySelector('.pdr-addtocart')) return;
    if (blockedNoSize()){ e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
})();
